<template>
  <v-app>
    <v-navigation-drawer
      v-if="!this.$vuetify.breakpoint.mdAndUp"
      v-model="isNavigationDrawerShown"
      :value="isNavigationDrawerShown"
      class="d-flex d-md-none"
      clipped
      right
      app
    >
      <v-list>
        <v-subheader>TELNET Systemy Teleinformatyczne Sp. z o. o.</v-subheader>
        <v-list-item-group v-model="selectedLinkButtonIndex" color="primary">
          <!-- OTHER -->
          <v-list-item
            v-for="(linkButton, i) in linkButtons"
            :key="i"
            @click="useLinkButton(linkButton)"
          >
            <font-awesome-icon
              class="mr-3"
              style="font-size: 24px;"
              :icon="linkButton.icon"
            ></font-awesome-icon>
            <v-list-item-title>{{ linkButton.text }}</v-list-item-title>
          </v-list-item>

          <!-- ADMIN PANEL -->
          <v-list-item
            v-if="$store.state.authentication.loggedIn"
            @click="$router.push('/admin')"
          >
            <font-awesome-icon
              class="mr-3"
              style="font-size: 24px;"
              :icon="['fas', 'user-tie']"
            ></font-awesome-icon>
            <v-list-item-title>Panel administratora </v-list-item-title>
          </v-list-item>

          <!-- LOGOUT -->
          <v-list-item
            v-if="$store.state.authentication.loggedIn"
            @click="logout()"
          >
            <font-awesome-icon
              class="mr-3"
              style="font-size: 24px;"
              :icon="['fas', 'sign-out-alt']"
            ></font-awesome-icon>
            <v-list-item-title>Wyloguj</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-right color="white">
      <v-container>
        <v-row>
          <!-- LOGO -->
          <v-col sm="2" align-self="center">
            <v-row justify="start">
              <v-btn
                @click="useLogoRoute()"
                rounded
                text
                class="brand-image-btn"
              >
                <img
                  src="@/assets/logo.webp"
                  alt="telnet-logo"
                  class="brand-image"
                />
              </v-btn>
            </v-row>
          </v-col>
          <!-- SPACER -->
          <v-spacer></v-spacer>
          <!-- NAVIGATION BUTTONS -->
          <v-col
            md="1"
            class="d-none d-md-flex"
            v-for="linkButton in linkButtons"
            :key="linkButton.text"
            style="justify-content: center"
          >
            <v-btn @click="useLinkButton(linkButton)" rounded text>
              <div
                class="v-btn-link"
                :class="
                  linkButton.hash === $router.currentRoute.hash
                    ? 'v-btn-link--highlighted'
                    : ''
                "
              >
                <span v-html="linkButton.text"></span>
              </div>
            </v-btn>
          </v-col>
          <v-col
            v-if="
              $store.state.authentication.loggedIn &&
                $vuetify.breakpoint.mdAndUp
            "
            md="2"
            style="justify-content: center"
          >
            <v-menu offset-y left slide-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn block color="primary" dark v-bind="attrs" v-on="on">
                  Admin
                  <font-awesome-icon
                    class="ml-2"
                    :icon="['fas', 'chevron-down']"
                  ></font-awesome-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="$router.push('/admin')">
                  <v-list-item-title>Panel administratora </v-list-item-title>
                </v-list-item>
                <v-list-item @click="logout()">
                  <v-list-item-title>Wyloguj</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <!-- BURGER BUTTON -->
          <v-col
            sm="1"
            class="d-flex d-md-none"
            v-if="$vuetify.breakpoint.smAndDown"
          >
            <v-row justify="end">
              <v-app-bar-nav-icon
                @click="isNavigationDrawerShown = true"
              ></v-app-bar-nav-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main id="auto-scrollable">
      <router-view class="mb-0"></router-view>
    </v-main>

    <v-footer color="#4A4A4A" class="justify-center pl-0" absolute inset app>
      <v-row justify="center" class="ma-0">
        <v-col style="text-align: center; font-size: 12px; color: #D9D9D9"
          > Piotr Seryło & Dawid Rzenno<br />
          Telnet Systemy Teleinformatyczne Sp. z o.o. &copy; 2024
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { $axios } from "@/axios";

export default {
  name: "app-layout-view",
  data: () => ({
    isNavigationDrawerShown: false,
    selectedLinkButtonIndex: 0,
    linkButtons: []
  }),
  mounted() {
    this.createNavButtons();
  },
  methods: {
    useLogoRoute() {
      this.$router.push({name: 'news'})
    },
    useLinkButton(linkButton) {
      if (linkButton.pathName) {
        this.$router.push({name: linkButton.pathName})
      } else if (linkButton.href) {
        window.location.href = linkButton.href;
      }

      this.createNavButtons();
    },

    logout: function() {
      $axios().get("/auth/logout");
      this.$store.commit("reset");
      this.$router.push("/");
    },

    createNavButtons() {
      this.linkButtons = [
        {
          text: "Nowości",
          icon: ["fas", "tag"],
          pathName: "news"
        },
        {
          text: "Oferta",
          icon: ["fas", "tag"],
          pathName: "offer"
        },
        {
          text: "Zarząd",
          icon: ["fas", "users"],
          pathName: "company-management"
        },
        {
          text: "Historia",
          icon: ["fas", "book"],
          pathName: "company-history"
        },
        {
          text: "Kontakt",
          icon: ["fas", "phone"],
          pathName: "contact"
        },
        {
          text: "RODO",
          icon: ["fas", "user-secret"],
          pathName: "privacy-policy"
        },
        {
          text: "Wsparcie",
          icon: ["fas", "headset"],
          href: "https://telnet.servicecamp.com/portal"
        },
        {
          text: "TeamViewer",
          icon: ["fas", "users"],
          href: "https://get.teamviewer.com/telnetqs"
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.brand-image {
  height: 30px;
  width: 140px;
}

.v-btn-link {
  font-size: 16px;
  text-transform: none;
  letter-spacing: 0;
  color: #707070;
}

.v-btn-link--bold {
  font-weight: 700;
}

.v-btn-link--highlighted {
  color: #19a7ab;
}

$grid-margin-on-sides: 160px;
.grid-margin-on-sides {
  padding-left: $grid-margin-on-sides;
  padding-right: $grid-margin-on-sides;
}

.brand-image-btn {
  padding: 0 !important;
}
</style>
